import { useEffect, useRef, useState } from "react"
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import { selectTranslations } from "../services/i18n/i18nSlice";
import UploadServer from "../api/UploadServer";
import Spinner from 'react-bootstrap/Spinner';
import upload_img from '../assets/images/upload.svg'
import { randomUid } from "../utils/utils";
import { ProgressBar } from "react-bootstrap";

export default function UploadButton({label="Upload", uploadId=randomUid(), type='', accept="*", folder_id=null, onUpload = null, className = '', showProgress = false}){

    const t = useSelector(selectTranslations)
    const [isUploading, setIsUploading] = useState(false)

    const [uploadProgress, setUploadProgress] = useState(0)

    const uploadRef = useRef()

    const setProgress = (total, current) => {
        setUploadProgress(Math.round((100 * current) / total))
    }

    const uploadFile = async (event) => {
        setIsUploading(true)
        if(type === ""){
            toast.error(t.upload.missing_file_type, {
                position: "top-right"
            })
            return;
        }

        if (uploadRef.current.files[0]) {
            let reader = new FormData();
            reader.append("file",uploadRef.current.files[0]);
            let response = await UploadServer({
                params: {
                    'file_type': type,
                    ...(folder_id && {
                        'folder_id': folder_id
                    })
                },
                endpoint: '/upload_file',
                body: reader,
                showProgress: showProgress,
                setUploadProgress: setProgress
            });
            if (response.success) {
                if(response?.data?.file_id){
                    toast.success(t.upload.file_uploaded, {
                        position: "top-right"
                    })
                    onUpload(`/get_file?file_id=${response?.data?.file_id}`)
                }
                else{
                    toast.error(t.upload.error_upload, {
                        position: "top-right"
                    })
                    return;
                }
            } else {
                setIsUploading(false)
                if (response.error === "Duplicates in user_id"){
                    toast.error(t.upload.error_upload, {
                        position: "top-right"
                    })
                    return;
                } else if (response.error === "uploaded file size exceeds maximum allowed file size") {
                    toast.error(t.upload.file_too_big, {
                        position: "top-right"
                    })
                    return;
                } else {
                    toast.error(t.upload.error_upload, {
                        position: "top-right"
                    })
                    return;
                }
            }
            setIsUploading(false)
        } else {
            toast.error(t.upload.error_upload, {
                position: "top-right"
            })
            setIsUploading(false)
            return;
        }     
    }

    return (
        <>
            <label htmlFor={`upload_input__${uploadId}`} className={"upload_button colored d-flex align-items-center "+className}>
                {isUploading ? 
                    <Spinner />
                : <>
                    <img src={upload_img} className="me-1" />
                    {label}
                </>}
            </label>
            <input id={`upload_input__${uploadId}`} accept={accept} type="file" ref={uploadRef} disabled={isUploading} hidden className="w-100 mt-2 standardInput" onChange={uploadFile} />
            {
                (isUploading && showProgress) &&
                <div style={{minWidth:"250px"}}>
                    <ProgressBar now={uploadProgress} max={100} />
                </div>
            }
        </>
    )
}